export default "__VITE_ASSET__2fb4d1c9__"